var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"textarea-wrapper"},[_c('label',{attrs:{"for":"textarea-id"}},[_vm._v("Message")]),_c('textarea',{attrs:{"id":"textarea-id"},domProps:{"value":_vm.value},on:{"input":_vm.handleInput}})])}
var staticRenderFns = []

export { render, staticRenderFns }